module.exports = __webpack_public_path__ + "img/zoom_v2_512x512.3d2339ac.png";